import React from "react";

const ConsultingButton = ({ ...props }) => {
  return (
    <button
      {...props}
      className="w-auto border text-sm border-[#FF861A] font-bold bg-alu-primary text-white py-4 px-2 rounded-s-lg hover:bg-[#ea6d00] flex flex-col items-center outline-none"
    >
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_16721_9484)">
            <path
              d="M18.3754 4.5H5.17543C4.26793 4.5 3.52543 5.2425 3.52543 6.15V21L6.82543 17.7H18.3754C19.2829 17.7 20.0254 16.9575 20.0254 16.05V6.15C20.0254 5.2425 19.2829 4.5 18.3754 4.5ZM18.3754 15.75H6.82543L5.40043 17.25V6.375H18.3754V15.75Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_16721_9484">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
      <p className="[writing-mode:vertical-rl] tracking-[0.25rem]">相談する</p>
    </button>
  );
};

export default ConsultingButton;
